import React, { useState } from 'react';
import { Typography } from 'antd';
import useJobsStore from 'Store/useJobsStore';
import { SbTooltip } from 'uiCore';
import DiffCheckerV2 from './DiffCheckerV2';
import { PageHeaderStyled, ModeTagStyled } from './SbJobCompareV2.styles';
import { HeadingRowStyled } from 'styles/common.styles';
import { COMPARE_VIEW, COMPARE_VIEW_LABELS, COMPARE_ENTRY, JD_TABS, JD_TAB_LABELS } from 'constants/jobs.constants';

const { Title } = Typography;

const TOOLTIP_COMPARE_JDS = "Compare any two job descriptions from your library.";

const SIDE_INITIAL_STATE = { selectedJob: null, versionData: [], selectedVersion: null };

const SbJobCompareV2 = ({ entryFrom } = {}) => {
  const compareViewSelection = useJobsStore((s) => s.compareViewSelection);
  const [viewMode, setViewMode] = useState(() => {
    if (entryFrom === COMPARE_ENTRY.JOBS_LIBRARY) return COMPARE_VIEW.SUMMARY;
    return compareViewSelection === '' ? COMPARE_VIEW.DIFFERENCE : compareViewSelection;
  });

  const [leftState, setLeftState] = useState(SIDE_INITIAL_STATE);
  const [rightState, setRightState] = useState(SIDE_INITIAL_STATE);

  return (
    <>
      {/* Main header + the active mode beside it as a subordinate tag —
          mirrors the title-plus-mode row pattern used across the app
          (see RedeploymentCenterV2 and SkillGapAccordion). */}
      <PageHeaderStyled>
        <HeadingRowStyled>
          <SbTooltip content={TOOLTIP_COMPARE_JDS}>
            <Title level={4}>{JD_TAB_LABELS[JD_TABS.JOB_COMPARE]}</Title>
          </SbTooltip>
          <ModeTagStyled>{COMPARE_VIEW_LABELS[viewMode]}</ModeTagStyled>
        </HeadingRowStyled>
      </PageHeaderStyled>
      <DiffCheckerV2
        viewMode={viewMode}
        setViewMode={setViewMode}
        leftState={leftState}
        setLeftState={setLeftState}
        rightState={rightState}
        setRightState={setRightState}
        entryFrom={entryFrom}
      />
    </>
  );
};

export default SbJobCompareV2;
